import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Table,
} from "reactstrap";
// core components
import { useState } from "react";
import axios from "axios";
import Header from "components/Headers/Header";
import img from "../../img/Simbolo_ICONTEC-2019-Pos.png";
import { useParams } from "react-router-dom";
import ContratosFirmadosCliente from "views/Crea/ContratosFirmadosCliente";
import Pruebas from "./PruebaHtmlPdf";
import CreaComentarios from "views/Crea/CreaComentarios";

const Autenticacion = (props) => {
  let { id } = useParams();
  const [postNombre, setPostNombre] = useState("");
  const [postCodigo, setPostCodigo] = useState("");

  const [list, setList] = useState([]);
  const [message, setMessage] = useState("");

  const postData = (e) => {
    e.preventDefault();

    if (!postCodigo || !postNombre) {
      setMessage("Por favor complete todos los campos.");
      return;
    }

    axios({
      method: "get",
      auth: {
        username: "",
        password: "",
      },
      url:
        "https://contratosback-dev.azurewebsites.net/api/v1/Valida/" +
        postCodigo +
        "/" +
        postNombre,
    })
      .then((Response) => {
        if (Response.status === 204) {
          setMessage("No hay información disponible.");
          setList([]);
        } else {
          setList(Response.data);
          setMessage("");
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };

  const NuevaConsulta = (e) => {
    e.preventDefault();
    window.location.reload("/");
  };
  return (
    <>
      <Header />
      <div className="d-flex justify-content-center">
        <Container className="mt--7" fluid>
          {list.length === 0 ? (
            <Row className="justify-content-center">
              <Col className="order-xl-1" xl="7">
                <Card className="bg-secondary shadow">
                  <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                      <Col className="text-right" xs="1"></Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <Form>
                      <center>
                        <img src={img} alt="login" width={160} />
                        <h6 className="heading-small text-muted mb-4">
                          INGRESAR INFORMACIÓN
                        </h6>
                      </center>
                      <div className="pl-lg-4">
                        <FormGroup>
                          <Input
                            className="form-control-alternative"
                            placeholder="Código Enviado"
                            type="number"
                            onChange={(e) => setPostCodigo(e.target.value)}
                            required
                          />
                        </FormGroup>
                        <FormGroup>
                          <Input
                            className="form-control-alternative"
                            placeholder="N° Contrato"
                            type="number"
                            onChange={(e) => setPostNombre(e.target.value)}
                            required
                          />
                        </FormGroup>

                        <center>
                          <button
                            className="btn btn-primary btn-lg"
                            color="primary"
                            onClick={postData}
                          >
                            CONSULTAR
                          </button>
                        </center>
                        {message && (
                          <div className="text-center text-danger mt-3">
                            {message}
                          </div>
                        )}
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row className="justify-content-center">
              <Col className="order-xl-1" xl="12">
                <Card className="bg-secondary shadow">
                  <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                      <Col className="text-right" xs="1"></Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">Id</th>
                          <th scope="col">Nombre</th>
                          <th scope="col">Ciudad</th>
                          <th scope="col">Dirección</th>
                          <th scope="col">Telefono</th>
                          <th scope="col">Contrato</th>
                          <th scope="col">Firmar</th>
                          <th scope="col">Comentarios</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.nombreProveedor}</td>
                              <td>{item.ciudad}</td>
                              <td>{item.direccion}</td>
                              <td>{item.telefono}</td>
                              <td>
                                <Pruebas id={item.id} />
                              </td>
                              <td>
                                <ContratosFirmadosCliente
                                  paso={item.pasoAprobacion}
                                  id={item.id}
                                />
                              </td>
                              <td>
                                <CreaComentarios
                                  paso={item.pasoAprobacion}
                                  id={item.id}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
                <button
                  className="btn btn-light btn-lg"
                  color="primary"
                  onClick={NuevaConsulta}
                >
                  NUEVA CONSULTA
                </button>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </>
  );
};

export default Autenticacion;
